var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoldArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold / Arrows / Alt Arrow Left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.64425 10.1759L13.4459 4.54991C13.8079 4.19886 14.5 4.41165 14.5 4.87402L14.5 16.126C14.5 16.5883 13.8079 16.8011 13.4459 16.4501L7.64425 10.8241C7.45192 10.6376 7.45192 10.3624 7.64425 10.1759Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldArrowLeft);
export default __webpack_public_path__ + "static/media/bold_arrow_left.33fa705414d510c6807eb4a0fc11fd15.svg";
export { ForwardRef as ReactComponent };